import { render, staticRenderFns } from "./PointsRule.vue?vue&type=template&id=4ce42ec0&"
import script from "./PointsRule.vue?vue&type=script&lang=js&"
export * from "./PointsRule.vue?vue&type=script&lang=js&"
import style0 from "./PointsRule.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports